import { render, staticRenderFns } from "./StudentThin.vue?vue&type=template&id=3ae59b0c&"
import script from "./StudentThin.vue?vue&type=script&lang=js&"
export * from "./StudentThin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports